import { createFileRoute } from "@tanstack/react-router";
import type { Id } from "@convex/_generated/dataModel";
import { DraftRoom } from "@/features/draft/components/DraftRoom";
import { PageContainer } from "@/shared/layout/PageContainer";

export const Route = createFileRoute("/_authenticated/leagues/$leagueId/draft")({
  component: DraftPage,
});

function DraftPage() {
  const { leagueId } = Route.useParams();
  return (
    <PageContainer>
      <DraftRoom leagueId={leagueId as Id<"leagues">} />
    </PageContainer>
  );
}
